<template>
  <div class="city-contain">
    <div class="city-box" v-for="item in rankList" :key="item.id">
      <div class="city-name" :style="{width:maxWidth}">{{item.id}}&#160;{{item.city}}</div>
      <div class="right-box">
        <div class="line-box">
          <div class="line" :style="'width:' + item.mark + '%'"></div>
        </div>
        <div class="mark">{{item.mark}}分</div>
        <div class="rank-box">
          <div class="up-up" v-if="item.change == 1">↑</div>
          <div class="down-down" v-if="item.change == 2">↓</div>
          <div class="num" v-if="item.change == 0">&#160;&#160;-</div>
          <div class="item.change == 1?'num-up':'num-down' num" v-else>{{item.changeRank}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'rankCharts',
        props: {
            'rankList': Array
        },
        data () {
            return {
                maxWidth: '30px'
            }
        },
        mounted () {
            let nameArry = []
            for (let index = 0; index < this.rankList.length; index++) {
                nameArry.push(this.rankList[index].city)
            }
            var longest = nameArry.sort(function (a, b) { return b.length - a.length; })[0];
            // console.log('longest:', longest.length)
            this.maxWidth = longest.length * 18.5 + 'px'
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.city-contain{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .city-box{
    border-bottom: 1px solid #eeeeee;
    height: 34px;
    width: 100%;
    display: flex;
    align-items: center;
    .city-name{
      display: flex;
      justify-content: flex-end;
      font-size:10px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:10px;
      white-space: nowrap;
    }
    .right-box{
      margin-left: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      .line-box{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        .line{
          height: 6px;
          background: #36B374;
        }
      }
      .mark{
        font-size:10px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:10px;
        margin-left: 12px;
        white-space: nowrap;
      }
      .rank-box{
        margin-left: 14.7px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        .up-up{
          font-size:10px;
          font-weight:400;
          color:rgba(54,179,116,1);
          line-height:10px;
          margin-bottom: 2.5px;
        }
        .down-down{
          font-size:10px;
          font-weight:400;
          color:rgba(255,77,77,1);
          line-height:10px;
          margin-bottom: 2.5px;
        }
        .num{
          font-size:10px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          line-height:10px;
          margin-left: 4px;
        }
        .num-up{
          color:rgba(54,179,116,1);
        }
        .num-down{
          color:rgba(255,77,77,1);
        }
      }
    }
  }
}
</style>
